var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('v-alert',{staticClass:"mt-2 mb-n5",attrs:{"type":_vm.type,"prominent":"","dense":"","dismissible":"","transition":"scroll-y-transition"},on:{"input":function($event){return _vm.hideAlert()}}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }